module.exports = __webpack_public_path__ + "static/img/7x_business_accelerator_1200x628-01.91593b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7x_business_accelerator_1200x628-01.png
// module id = gKPb
// module chunks = 1